/* @flow */

import React from 'react';
import styled from 'styled-components';

import FlexBox from './FlexBox';
import Icon from './Icon';

const AlertBox = styled(FlexBox)`
  font-family: ${({ theme }) => theme.fontIBMRegular};
  width: 100%;
  border-radius: 4px;
  padding: 10px 20px;
  font-size: 14px;
  line-height: 1.5;
  ${({ type }) => {
    if (type === 'danger') {
      return 'background-color: rgba(242,48,81,0.06);color:rgba(242,48,81,1);';
    }
    return 'background-color: rgba(220,169,10,0.06);color:rgba(220,169,10,1);';
  }}
  .iconfont {
    margin-right: 12px;
    line-height: 100%;
  }
`;

type Props = {
  type: string,
  children: any,
}


const AlertInfo = ({ children, type }: Props) => (
  <AlertBox type={type} wrap="nowrap" align="normal">
    <Icon type="tips" size={20} />
    {children}
  </AlertBox>
);

AlertInfo.defaultProps = {
  type: 'warning',
  children: '',
};

export default AlertInfo;
